const T = require('prop-types');
const { default: Styled } = require('styled-components');
const { context } = require('app-context');

const Debounce = require('lodash/debounce');

const { default: TextField } = require('@mui/material/TextField');
const { default: SearchIcon } = require('@mui/icons-material/Search');
const { default: Paper } = require('@mui/material/Paper');

const { actions } = context;

const redux = context.redux.hooks;

const internals = {};

const requestSearch = Debounce(
    (q) => redux.dispatch(actions.dataFetching.fetchGroupSearchResults(q)),
    200,
    { leading: false, trailing: true }
);

const ManageGroupsSearchField = (props) => {

    const {
        isMe,
        userId,
        searchText,
        setSearchText
    } = props;

    const {
        SearchWrapper,
        StyledTextField,
        StyledSearchContainer,
        StyledSearchIcon
    } = internals;

    const onSearchChange = (evt) => {

        const newSearchText = evt.target.value;

        setSearchText(newSearchText);

        const searchObj = {
            searchText: newSearchText,
            showAll: true
        };

        if (!isMe) {
            searchObj.managedUserId = userId;
        }

        requestSearch(searchObj);
    };

    return (
        <SearchWrapper>
            <StyledSearchContainer elevation={0}>
                <StyledSearchIcon />
                <StyledTextField
                    placeholder='Search groups'
                    primary
                    fullWidth
                    InputProps={{
                        disableUnderline: true,
                        style: { backgroundColor: 'transparent' }
                    }}
                    inputProps={{
                        'aria-label': 'Search groups'
                    }}
                    value={searchText}
                    onChange={onSearchChange}
                />
            </StyledSearchContainer>
        </SearchWrapper>
    );
};

ManageGroupsSearchField.propTypes = {
    isMe: T.bool,
    userId: T.number,
    searchText: T.string,
    setSearchText: T.func
};

module.exports = ManageGroupsSearchField;

internals.Label = Styled.div`
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
`;

internals.SearchWrapper = Styled.div`
    padding: 14px 20px 14px;
    background: white;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    margin: 0 auto;
`;

internals.StyledSearchContainer = Styled(Paper)`
    width: 100%;
    max-width: 560px;
    height: 52px;
    min-height: 52px;
    box-sizing: border-box;
    margin: auto;
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.palette.tertiary.main};
    color: ${({ theme }) => theme.palette.tertiary.contrastText};
    padding: 0 16px;
    cursor: text;
    border: 1px solid rgba(18, 39, 79, 0.28) !important;
    border-radius: 8px;
    box-shadow: none !important;
    gap: 12px;
`;

internals.StyledSearchIcon = Styled(SearchIcon)`
    color: ${({ theme }) => theme.palette.tertiary.contrastText};
    flex: 0 0 auto;
`;

internals.StyledTextField = Styled(TextField)`
    .MuiInputBase-root {
        padding: 0;
    }
    .MuiInputLabel-root {
        display: none;
    }

    .MuiInputBase-input {
        color: #ffffff;
        -webkit-text-fill-color: #ffffff;
        font-weight: 400;
        &::placeholder {
            color: #ffffff;
            -webkit-text-fill-color: #ffffff;
            opacity: 1;
            font-weight: 400;
        }
    }
    .MuiInput-underline:before,
    .MuiInput-underline:after {
        display: none;
    }
`;